module.exports = __webpack_public_path__ + "static/media/salir.7b6a0cad.png";